import { useCallback, useEffect, useState } from "react";
import { FullPageTemplate } from "../../modules/programsLayout/fullPageTemplate";
import FaqBg from "../../assets/images/faqBg.jpg";
import { Link, useSearchParams } from "react-router-dom";
import NewsFeed from "./components/newsFeed";
import api from "src/services/api";
import { ErrorMessages } from "src/constants/errorMessages";
import { exceptionHandler } from "src/utils/helper";
import { useAlertStore } from "src/store/alert";
import Pagination from "src/modules/pagination";

const QUERY_KEY = {
  TAKE: "take",
  SKIP: "skip",
  PAGE: "page",
};
const TAKE = 10;

export default function NewsAndUpdates() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [totalPromotion, setTotalPromotion] = useState(0);
  const { setAlert } = useAlertStore();

  const activePage = searchParams.get(QUERY_KEY.PAGE) || 1;
  const pages = Math.ceil(totalPromotion / TAKE);

  const onPageChange = useCallback((val: string | number) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(QUERY_KEY.PAGE, (+val + 1).toString());
    setSearchParams(searchParams);
  }, []);

  useEffect(() => {
    init();
  }, [searchParams.toString()]);

  const init = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams(window.location.search);
      params.set(QUERY_KEY.TAKE, String(TAKE));
      params.set(QUERY_KEY.SKIP, ((+activePage - 1) * TAKE).toString());
      const res = await api.newsFeed.list(`?${params.toString()}`);
      if (res.status === 200) {
        if (Array.isArray(res?.data?.items)) {
          setTotalPromotion(res?.data?.total);
          setNewsList(res?.data?.items);
        }
      } else {
        throw new Error(ErrorMessages.SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      exceptionHandler(error, setAlert, "destructive");
    } finally {
      setLoading(false);
    }
  }

  return (
    <FullPageTemplate desktopBg={FaqBg} mobileBg={FaqBg} bannerTitle={"TBS News & Updates"} loading={loading}>
      <div className="max-w-[1090px] m-auto 3xs:px-[20px] xs:px-[50px] md:px-[90px] mdtab:px-[135px] pb-[0px]">
        {/* <div className="flex justify-center pb-[60px]">
          <h2 className="text-[24px] text-center align-middle font-MetropolisBold leading-[34px]">
            Find the answers to all of our most frequently asked questions
          </h2>
        </div> */}
        {newsList.length > 0 ?
          <NewsFeed data={newsList} /> : (<p className="text-center text-[16px] font-Metropolis">No news updates available</p>)}
        <div className="flex flex-col gap-[20px] text-center pt-[60px]">
          <p className="leading-[20px] text-[14px]">
            For support, please contact{" "}
            {/* <Link className="text-[#D06F1A] underline font-bold" to={PageRoutes.HOME}> */}
            <Link
              className="text-[#D06F1A] hover:underline font-bold text-[14px] leading-[20px]"
              to="mailto:brewerprograms@thebeerstore.ca"
            >
              brewerprograms@thebeerstore.ca
            </Link>{" "}
          </p>
        </div>
        {pages > 1 && !loading ? (
          <div className="flex justify-center items-center w-[100%] mt-[30px] md:mt-[40px]">
            <div className="flex items-center gap-[10px] md:gap-[20px]">
              <Pagination
                    pages={pages}
                    activePage={((!isNaN(+activePage) && +activePage) || 1) - 1}
                    handler={onPageChange}
                  />
            </div>
          </div>
        ) : null}
      </div>
    </FullPageTemplate>
  );
}

